/**
 * @author        Pavlo Androshchuk
 * @copyright     Copyright (c) 2022, Zumper
 * @description   Additional building data for listings
 */

import { Bizo, autoclass } from '../../shared/bizos/base'

const AdditionalBuildingData = autoclass(
  'AdditionalBuildingData',
  class AdditionalBuildingData extends Bizo {},
  {
    buildingId: 'building_id',
    minLeaseDays: 'min_lease_days',
    rentSpecialInfo: 'rent_special_info',
    truncatedDescription: 'truncated_description',
    petPolicy: 'pet_policy_json',
  }
)
export default AdditionalBuildingData
